import { Step } from "@storebrand-digital/insurance-stepper";
import { CHECKOUT_STEPS } from "Components/Features/CheckOut/checkoutSteps";
import { MainPath } from "Constants/constants";

export const RENTAL_INTRO_STEP: Step = {
  id: "om-utleieboligen",
  title: "Om utleieboligen",
  ariaLabel: `${MainPath.CHECK_PRICE}-om-utleieboligen`,
  complete: false,
};

export const RENTAL_PRICE_STEP: Step = {
  id: "sjekk-pris",
  title: "Sjekk pris",
  ariaLabel: `${MainPath.CHECK_PRICE}-sjekk-pris`,
  complete: false,
};

export const RENTAL_STEPS: Step[] = [
  RENTAL_INTRO_STEP,
  RENTAL_PRICE_STEP,
  ...CHECKOUT_STEPS,
];
